import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { getTorqueDataPoints } from "./getTorqueDataPoints";
import type { OperatingPoint } from "@/components/types";
import type { PumpSpeedDataSet } from "./d";

export const usePumpSpeedTorqueChartData = (
  scenarioCalculations: ScenarioCalculations
): PumpSpeedDataSet | undefined => {
  const pump = scenarioCalculations.primaryPump.value;
  if (!pump) return undefined;

  const context = {
    requiredPumpBrakeHP:
      scenarioCalculations.pumpCalculations.aggregate.requiredPumpBrakeHP.value,
    operatingRPM:
      scenarioCalculations.pumpCalculations.aggregate.operatingRPM.value,
    pumpTorqueFtLbs:
      scenarioCalculations.pumpCalculations.aggregate.pumpTorqueFtLbs.value
  };

  // Get torque dataset
  const torqueDataSet = getTorqueDataPoints(context);
  const operatingPoint: OperatingPoint = {
    point: {
      x: context.operatingRPM,
      y: context.pumpTorqueFtLbs
    },
    label: "Operating Point",
    xLabel: torqueDataSet.xAxisLabel,
    yLabel: torqueDataSet.yAxisLabel
  };

  return {
    context,
    dataSets: {
      torque: torqueDataSet
    },
    operatingPoint
  };
};
